import React from 'react'
import styles from './Step4.scss'
import { s2dMessages } from '../../../intlMessages'
import { S2DLayout } from '../../../S2DLayout'
import { Msg } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

import androidRideThisMp4 from 'assets/images/send_to_device/android_ride_this.mp4'
import androidRideThisWebm from 'assets/images/send_to_device/android_ride_this.webm'

import iosRideThisMp4 from 'assets/images/send_to_device/ios_ride_this.mp4'
import iosRideThisWebm from 'assets/images/send_to_device/ios_ride_this.webm'

export class Step4 extends React.PureComponent {
  render () {
    const { title, subtitle, step, onPrev, route, selectedDevice, stepCount } = this.props
    const mp4 = selectedDevice === 'iphone'
      ? iosRideThisMp4
      : androidRideThisMp4
    const webm = selectedDevice === 'iphone'
      ? iosRideThisWebm
      : androidRideThisWebm
    return (
      <S2DLayout
        title={title}
        subtitle={subtitle}
        step={step}
        onClickNext={() => { window.location.href = `/routes/${route.id}` }}
        onClickPrev={onPrev}
        stepCount={stepCount}
        nextText={<Msg m={s2dMessages.returnToRoute} />}>
        <div className={styles.Step4}>
          <div>
            <video width='240' height='426' autoPlay muted loop key='step3'>
              <source src={webm} type='video/webm' />
              <source src={mp4} type='video/mp4' />
            </video>
          </div>
          <div>
            <h3>
              <T
                id='s2d.mobileFlow41'
                defaultMessage="When you're ready to navigate, tap the <strong>Navigate</strong> button at the bottom of the screen."
                values={{ strong: (...c) => <strong>{c}</strong> }} />
            </h3>
            <h3><T id='s2d.mobileFlow42' defaultMessage='After a brief warmup, you will be ready to go.' /></h3>
            <h3><Msg m={s2dMessages.enjoyYrRide} /></h3>
          </div>
        </div>
      </S2DLayout>
    )
  }
}
